import { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  homeSelector,
  setIsServicesPopupVisible,
  setScrollPosition,
  setSelectedServiceOrder,
  setServicesPopupStyle,
  setStatusbarColor,
} from "../featurs/homeSlice";

const useToggleServicesPopup = () => {
  const { isServicesPopupVisible, statusbarColor } = useSelector(homeSelector);
  const dispatch = useDispatch();
  const cache = useRef("#292929");

  const toggleServicesPopup = (e = null, selectedOrder) => {
    if (e != null) {
      /* currentTarget, not target: the click lands on the tile's inner <img> or
       * <p>, so e.target's rect is a CHILD's box and the popup grew from the
       * wrong point. The element the handler is bound to is the tile. */
      const el = e.currentTarget || e.target;
      const rect = el.getBoundingClientRect();
      const centerX = rect.left + rect.width / 2;
      const centerY = rect.top + rect.height / 2;

      /* Stored as viewport PERCENTAGES so they can drive transform-origin on a
       * full-screen panel. The popup used to animate width/height/top/left
       * from these as pixels — four layout properties, per frame. */
      dispatch(
        setServicesPopupStyle({
          "--origin-x": `${(centerX / window.innerWidth) * 100}%`,
          "--origin-y": `${(centerY / window.innerHeight) * 100}%`,
        })
      );
    }

    dispatch(setSelectedServiceOrder(selectedOrder > 0 ? selectedOrder : 0));

    // `isServicesPopupVisible` is the pre-dispatch value; derive next visibility.
    const willBeVisible = !isServicesPopupVisible;

    if (willBeVisible) {
      cache.current = statusbarColor || cache.current;
      dispatch(setScrollPosition(window.scrollY));
      dispatch(setStatusbarColor("#181717"));
    } else {
      dispatch(setStatusbarColor(cache.current));
    }

    dispatch(setIsServicesPopupVisible());
  };
  return toggleServicesPopup;
};

export { useToggleServicesPopup };
